<script>
import axios from 'axios'
import moment from 'moment/moment'
const _ = require('lodash')
import EmailBody from '@/components/execution/EmailBody.vue'
export default {
  name: 'ExecutionEmail',
  computed: {
    moment() {
      return moment
    }
  },
  components: { EmailBody },
  props: {
    execution: {
      type: Object,
      required: true
    }
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.current.page ||
            this.pagination.rowsPerPage !== this.current.rowsPerPage ||
            this.pagination.sortBy !== this.current.sortBy ||
            this.pagination.descending !== this.current.descending
          ) {
            this.current.page = this.pagination.page
            this.current.rowsPerPage = this.pagination.rowsPerPage
            this.current.sortBy = this.pagination.sortBy
            this.current.descending = this.pagination.descending
            this.getItems()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  data: () => ({
    headerOutBoundEmails: [
      {
        text: 'Purpose / Id',
        align: 'left',
        value: 'hexId',
        sortable: false
      },
      { text: 'Status', value: 'emailStatus' },
      { text: 'Initiated At', value: 'createdAt' },
      { text: 'Last Sent At', value: 'changedAt' },
      { text: 'No. of Retries', value: 'retryCount', align: 'right' },
      { text: 'Re-send', value: 'action', align: 'center', sortable: false }
    ],
    outBoundEmailLoading: false,
    outBoundEmails: [],
    searchOutBoundEmails: '',
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false,
      totalItems: 0
    },
    current: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false
    },
    rowsPerPageItems: [5, 10, 25]
  }),

  mounted() {
    this.getItems()
  },

  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    reSendEmail(id) {
      this.outBoundEmailLoading = true
      axios
        .post(`/api/v1/outBoundEmails/${id}/resend`)
        .then(response => {
          this.outBoundEmailLoading = false
          this.getItems()
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Error in re-send email',
            description: 'Error while re-sending email, please try again later or contact support',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.outBoundEmailLoading = false
        })
    },
    getUrlParams() {
      let urlParams = ''
      //fill URL Params from current structure

      urlParams += `&page=${this.current.page}`
      urlParams += `&size=${this.current.rowsPerPage}`
      if (this.current.sortBy) {
        urlParams += `&sort=${this.current.sortBy}`
        if (this.current.descending) {
          urlParams += `,desc`
        }
      }
      if (this.searchOutBoundEmails) {
      }
      return urlParams
    },
    getItems() {
      this.outBoundEmailLoading = true
      const urlParams = this.getUrlParams()
      axios
        .get(
          `/api/v1/outBoundEmails?executionId=${this.execution.hexId}${urlParams}`
        )
        .then(response => {
          if (response.data._embedded) {
            this.pagination.totalItems = response.data.page.totalElements
            this.outBoundEmails = response.data._embedded.outBoundEmails
            this.outBoundEmailLoading = false
          } else {
            this.pagination.totalItems = 0
            this.outBoundEmails = []
            this.outBoundEmailLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.outBoundEmailLoading = false
        })
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3"
        >Outbound emails sent as part of the workflow execution
      </span>
      <v-spacer />
      <!--      <v-list-tile-avatar>-->
      <!--        <v-icon>search</v-icon>-->
      <!--      </v-list-tile-avatar>-->
      <!--      <v-list-tile-content>-->
      <!--        <v-list-tile-sub-title>-->
      <!--          <v-text-field-->
      <!--            v-model="searchOutBoundEmails"-->
      <!--            color="secondary"-->
      <!--            label="Search based on purpose"-->
      <!--            xs5-->
      <!--          >-->
      <!--          </v-text-field>-->
      <!--        </v-list-tile-sub-title>-->
      <!--      </v-list-tile-content>-->
      <!--      <v-tooltip bottom>-->
      <!--        <v-btn slot="activator" flat icon @click="searchOutBoundEmails = ''">-->
      <!--          <v-icon>clear</v-icon>-->
      <!--        </v-btn>-->
      <!--        <span>Clear search</span>-->
      <!--      </v-tooltip>-->
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getItems()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headerOutBoundEmails"
        :items="outBoundEmails"
        :loading="outBoundEmailLoading"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="pagination.totalItems"
        item-key="hexId"
      >
        <v-progress-linear slot="progress" color="accent" indeterminate />
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class="body-2 font-weight-bold orange--text">
                {{ format(props.item.emailPurpose) }}
              </div>
              <div class="caption">
                {{ props.item.hexId }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div
                :class="
                  props.item.emailStatus === 'FAILED'
                    ? 'red--text'
                    : props.item.emailStatus === 'PENDING'
                    ? 'grey--text'
                    : 'green--text' + ' body-1 font-weight-bold'
                "
              >
                {{ format(props.item.emailStatus) }}
              </div>
            </td>

            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{
                moment(props.item.createdAt)
                  .utc()
                  .local()
                  .format('DD MMM YYYY hh:mm:ss a')
              }}
            </td>

            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{
                moment(props.item.changedAt)
                  .utc()
                  .local()
                  .format('DD MMM YYYY hh:mm:ss a')
              }}
            </td>

            <td class="text-xs-right" @click="props.expanded = !props.expanded">
              {{ props.item.retryCount }}
            </td>
            <td class="text-left">
              <v-btn
                small
                icon
                flat
                class="mt-2"
                @click="reSendEmail(props.item.hexId)"
              >
                <v-icon>
                  published_with_changes
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-flex>
            <email-body :mail="props.item.emailSendModel" />
          </v-flex>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="warning" icon="warning">
            No OutBound emails sent!
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
